import styled from 'styled-components';

export const Base = styled.div`
	margin-left: 13px;
	padding-right: 18px;
`;

export const PropertyValue = styled.div`
	// layout
	width: 100%;

	// style
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: text;
	white-space: pre-wrap;
	margin-bottom: 16px;
`;

export const DesignNotes = styled.div`
	// layout
	margin-bottom: 16px;
	margin-top: 14px;
	display: flex;
	flex-direction: column;

	// style - similar to SystemMessage for consistency
	font-size: 13px;
	font-family: 'Inter', sans-serif;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: text;
	line-height: 20px;
`;

export const DesignNotesSpacer = styled.div`
	height: 16px;
`;
